import React from 'react';
import { nanoid } from 'nanoid';
import { Box, LayoutProps, Stack } from '@chakra-ui/react';
import SectionTitle from './SectionTitle';
import Card, { CardProps } from './Card';

interface CardGridProps {
  gridTitle: string;
  rows: CardProps[][];
  minCardHeight?: LayoutProps['minH'];
  minCardBodyHeight?: LayoutProps['minH'];
  hideLearnMore?: boolean;
}

const CardGrid = ({
  gridTitle,
  rows,
  minCardHeight = undefined,
  minCardBodyHeight = undefined,
  hideLearnMore = false,
}: CardGridProps) => (
  <Box maxW="7xl" mx="auto" p={['5', '10']}>
    <SectionTitle title={gridTitle} />
    {rows.map(row => (
      <Stack
        key={nanoid()}
        direction={['column', 'column', 'row']}
        justify="center"
        spacing={['10', '10', '5', '20']}
        mb="12"
      >
        {row.map(({ title, body, href, learnMoreDescription }) => (
          <Card
            key={title}
            title={title}
            body={body}
            href={href}
            containerMinHeight={minCardHeight}
            bodyMinHeight={minCardBodyHeight}
            hideLearnMore={hideLearnMore}
            learnMoreDescription={learnMoreDescription}
          />
        ))}
      </Stack>
    ))}
  </Box>
);

CardGrid.defaultProps = {
  hideLearnMore: false,
  minCardHeight: undefined,
  minCardBodyHeight: undefined,
};

export default CardGrid;
